import {
  getSetupAreaVersionStatusLabel,
  SetupAreaVersion, SetupAreaVersionStatus
} from 'nekst-api';
import { TextBadge, TextBadgeStyle } from 'features/tasks-forms';
import React from 'react';

export function SetupAreaVersionStatusWidget(props: {
  setupAreaVersion: SetupAreaVersion
}) {
  let badgeStyle = TextBadgeStyle.ACTIVE;

  const version = props.setupAreaVersion;

  switch (version.status) {
    case SetupAreaVersionStatus.PUBLISHED:
      badgeStyle = TextBadgeStyle.ACTIVE;
      break;
    case SetupAreaVersionStatus.ARCHIVED:
      badgeStyle = TextBadgeStyle.INACTIVE;
      break;
    case SetupAreaVersionStatus.DRAFT:
      badgeStyle = TextBadgeStyle.DRAFT;
      break;
  }

  return (
    <TextBadge text={getSetupAreaVersionStatusLabel(version.status)} style={badgeStyle}  />
  );
}
